import React, { useState } from "react";
import { FormControlLabel, Button, Checkbox } from "@material-ui/core";
import useBDocTranslator from "../hooks/useBDocTranslator";
import Axios from "axios";
import useUserState from "../hooks/useUserState";

export default function ConsultationNotesEHR({ appointmentId }) {
  const [checked, setChecked] = useState(true);
  const { t } = useBDocTranslator();
  const userLocalState = useUserState();
  const [consultationNotes, setConsultationNotes] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  //Method for Save the prescription
  const handleConsultationNotesSave = async () => {
    try {
      setIsLoading(true);
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL_BASE}/consultations/create`,
        {
          appointment_id: appointmentId,
          note: consultationNotes,
          created_by_userId: userLocalState[0].user.id,
          is_draft: false,
          visibility: checked,
        },
        {
          headers: { Authorization: "Bearer " + userLocalState[0].jwt },
        }
      );

      setResponseMessage("Consultation notes saved successfully");
      setConsultationNotes("");
    } catch (error) {
      console.log(error);
      setResponseMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="shadow p-3 m-2 bg-white rounded-lg col-md-12 col-sm-12 position-relative prescription-card">
      <div className="col-sm-12 col-md-12 mt-1 text-center">
        {responseMessage && (
          <p className="font-weight-bold">{t(responseMessage)}</p>
        )}
      </div>
      <textarea
        name="consultation-notes-txt"
        id="consultation-notes-txt"
        rows="10"
        placeholder={t(
          "Consultation Notes Here, click to Pen button if you want minimize this section (the text entered will not be lost)"
        )}
        className="mb-3 w-100 h-60-custom form-control col-md-12"
        onChange={(e) => setConsultationNotes(e.target.value)}
        value={consultationNotes}
      ></textarea>
      <div className="row col-sm-12">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleConsultationNotesSave();
          }}
          className="col-md-6"
          disabled={isLoading}
        >
          {isLoading ? t("Saving...") : t("Save")}
        </Button>
        <div className="pl-3">
          <FormControlLabel
            control={<Checkbox checked={checked} onChange={handleChange} />}
            label={t("Note visible")}
          />
        </div>
      </div>
    </div>
  );
}
